import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_VMS_URL

export const get = async (queryParam, filters) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: filters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/vendor',
    params: params,
  })

  return response?.data
}

export const getWithFilters = (filters) => async (queryParam) => await get(queryParam, filters)

export const getRates = async (queryParam, filters, origin_address_id, destination_address_id) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: filters || undefined,
    origin_address_id,
    destination_address_id,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/vendor/rates',
    params: params,
  })

  return response?.data
}

export const getRatesWithFilters =
  (filters, origin_address_id, destination_address_id) => async (queryParam) =>
    await getRates(queryParam, filters, origin_address_id, destination_address_id)

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/vendor/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/vendor',
    data,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/vendor/${id}`,
    data,
  })

  // If no data but status is 200
  if (!response?.data && String(response?.status).startsWith('2')) {
    return 'OK'
  }

  return response?.data
}

export const deleteSingle = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `/vendor/${id}`,
  })

  return response?.data
}

export const deleteBulk = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: '/vendor/bulk',
    data,
  })

  return response?.data
}

export const getContractRates = async (queryParam, filters) => {
  const defaultFilter = !filters ? ['status.name eq ACTIVE', 'paired_company_id gt 0'] : filters
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: defaultFilter || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/vendor/contract-rates',
    params: params,
  })

  return response?.data
}